import { Button, Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useState } from 'react';
import { createDownLoadVersion, updateDownLoadVersion } from '../../../api';
import { messageError, messageWarning } from '../../../components/message';
import {
  IDownLoadMenu,
  IDownLoadType,
  IDownLoadVersionMenu,
  IEngineItem,
  DownloadEngine,
  DownloadObjectType,
  IDownLoadVersionUpdateConfig,
  DownloadPlatformType,
  CommonStatusStep,
  ISecondEngineItem,
} from '../../../model/api-modules';
import { AddEngine } from './lib/add-engine';
import moment from 'moment';
import getFormatMessage from '../../../locales/get-format-message';

import { ISiteIDownLoadVersionMenu } from './download-version';
import { ISiteIDownLoadMenu } from './download-items';
import {
  getDownloadVersionMatcher,
  getSiteMatchedDownloadVersion,
  getSiteMatchedObjectId,
  handleMultiSiteSubmitRes,
  IMultiSubmitRes,
  multiSiteSubmitter,
} from './lib/multi-site-helper';
import { getFirstManageSite, getNeedManageSites } from '../../../lib';
import { ConsoleDrawer } from '../../../components/drawer';
import { ConsoleForm } from '../../../components/form';
import { CommonInput, CommonTextArea } from '../../../components/input';
import { CommonSelect } from '../../../components/select';
import { MultiSiteStatus } from '../components/multi-site-status';
import { omit } from 'lodash';
import {
  SelectViewField,
  TextViewField,
} from '../../../components/form/view-field';
import { shortHash10 } from '../lib/hash';

interface IProps {
  readonly allSiteDownLoadList: ISiteIDownLoadMenu;
  readonly allSiteDownLoadVersionList: ISiteIDownLoadVersionMenu;
  readonly onClose: (status?: boolean) => void;
  readonly row: IDownLoadVersionMenu | null;
  readonly type: IDownLoadType;
}

export const DownLoadVersionDrawer = (props: IProps) => {
  const { allSiteDownLoadList, allSiteDownLoadVersionList, type } = props;
  const [form] = useForm<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  const [downLoadList, setDownLoadList] = useState<
    ReadonlyArray<IDownLoadMenu>
  >(allSiteDownLoadList[getFirstManageSite()] || []);

  const [engineJson, setEngineJson] = useState<IEngineItem[]>([]);
  const [selectDownloadObjectType, setSelectDownloadObjectType] =
    useState<number>(1);
  const [selectDownloadObjectName, setSelectDownloadObjectName] =
    useState<string>('');
  const [secondList, setSecondList] = useState<IDownLoadMenu[]>([]);
  const [secondJson, setSecondJson] = useState<
    Record<string, ISecondEngineItem[]>
  >({});
  const isViewOnly = type === IDownLoadType.View;
  useEffect(() => {
    handleAddEngine();
  }, []);

  useEffect(() => {
    setDownLoadList(allSiteDownLoadList[getFirstManageSite()] || []);
  }, [allSiteDownLoadList]);

  const getFirstDownload = () => {
    const firstList = downLoadList.filter((item) => {
      return !item.ParentTag;
    });
    const firstOptions = firstList.map((item) => {
      return {
        label: item.Name,
        value: item.id,
        type: item.Type,
      };
    });
    return firstOptions;
  };

  const getModalTitle = () => {
    if (props.type === IDownLoadType.Create) {
      return getFormatMessage('create_version');
    }
    if (props.type === IDownLoadType.View) {
      return getFormatMessage('查看版本');
    }
    return getFormatMessage('edit_version');
  };

  const handleNameSelectChange = (value: any) => {
    const matchingItem = downLoadList.find((item) => item.id === value);
    if (matchingItem) {
      const correspondingType = matchingItem.Type;
      const correspondingName = matchingItem.Name;
      setSelectDownloadObjectType(correspondingType);
      setSelectDownloadObjectName(correspondingName);
    }

    const currnetSecondList = downLoadList.filter((item) => {
      return !!item.ParentID && item.ParentID === value;
    });
    setSecondList(currnetSecondList);
  };
  const getSuccessMessage = () => {
    return props.type === IDownLoadType.Create
      ? getFormatMessage('create_success')
      : getFormatMessage('edit_success');
  };
  const handleOpenCancel = () => {
    form.resetFields();
    props.onClose();
  };
  const handleOpenSubmit = async () => {
    console.log('engineJson==', engineJson);
    const values = await form.validateFields();
    if (!values) {
      return false;
    }
    // console.log('对应的Type值==', selectDownloadObjectType);
    const newEngineJson: IEngineItem[] = [];
    const newSecondJson: Record<string, ISecondEngineItem[]> = {};

    if (
      secondList.length === 0 ||
      (props.row?.EngineJson.length !== 0 && props.type === IDownLoadType.Edit)
    ) {
      for (const item of engineJson) {
        // engineJson.forEach((item: IEngineItem) => {
        let typeValue: DownloadEngine = DownloadEngine.CPP; // 默认c++
        if (selectDownloadObjectType === DownloadObjectType.Client) {
          typeValue = item.type;
        } else if (selectDownloadObjectType === DownloadObjectType.Sample) {
          typeValue = DownloadEngine.Windows;
        } else if (selectDownloadObjectType === DownloadObjectType.Server) {
          typeValue = DownloadEngine.WinMsvC;
        } else if (selectDownloadObjectType === DownloadObjectType.Tools) {
          typeValue = DownloadEngine.Zip;
        }
        const isUe = item.type === 1;
        const isUnity = item.type === 3;
        const psSdkContents = item.openPSSDKVersion ? item.pssdkVersion : [];
        const gdkContents = item.openGDKVersion ? item.gdkVersion : [];
        const hasPSPlatform =
          item.platform.includes(DownloadPlatformType.PS4) ||
          item.platform.includes(DownloadPlatformType.PS5);

        const hasXSXPlatform = item.platform.includes(DownloadPlatformType.XSX);

        const engineNeedPSOrGDK = isUe || isUnity;

        // UE引擎,Unity引擎必填这两个版本
        // 选择了PS4/5,必须填 PS SDK版本
        // 选了XSX必须填 GDK版本
        if (
          engineNeedPSOrGDK &&
          hasPSPlatform &&
          hasXSXPlatform &&
          !psSdkContents.length &&
          !gdkContents.length
        ) {
          messageWarning(
            getFormatMessage('ps_sdk_version_and_gdk_version_required')
          );
          return false;
        }

        if (engineNeedPSOrGDK && hasXSXPlatform && !gdkContents.length) {
          messageWarning(getFormatMessage('gdk_version_required'));
          return false;
        }

        if (engineNeedPSOrGDK && hasPSPlatform && !psSdkContents.length) {
          messageWarning(getFormatMessage('ps_sdk_version_required'));
          return false;
        }

        console.log('对应的typeValue==', typeValue);
        newEngineJson.push({
          type: typeValue,
          version: item.version || [],
          platform: item.platform,
          package: item.package,
          gdkVersion: item.openGDKVersion ? item.gdkVersion : [],
          pssdkVersion: item.openPSSDKVersion ? item.pssdkVersion : [],
        });
      }
    } else {
      for (const i of Object.keys(secondJson)) {
        const secondJsonItem = secondJson[i];
        const newSecondItem = [];
        for (const it of secondJsonItem) {
          const currentSecondJson = [];
          for (const item of it.EngineJson) {
            // engineJson.forEach((item: IEngineItem) => {
            let typeValue: DownloadEngine = DownloadEngine.CPP; // 默认c++
            if (selectDownloadObjectType === DownloadObjectType.Client) {
              typeValue = item.type;
            } else if (selectDownloadObjectType === DownloadObjectType.Sample) {
              typeValue = DownloadEngine.Windows;
            } else if (selectDownloadObjectType === DownloadObjectType.Server) {
              typeValue = DownloadEngine.WinMsvC;
            } else if (selectDownloadObjectType === DownloadObjectType.Tools) {
              typeValue = DownloadEngine.Zip;
            }
            const isUe = item.type === 1;
            const isUnity = item.type === 3;
            const psSdkContents = item.openPSSDKVersion
              ? item.pssdkVersion
              : [];
            const gdkContents = item.openGDKVersion ? item.gdkVersion : [];
            const hasPSPlatform =
              item.platform.includes(DownloadPlatformType.PS4) ||
              item.platform.includes(DownloadPlatformType.PS5);

            const hasXSXPlatform = item.platform.includes(
              DownloadPlatformType.XSX
            );

            const engineNeedPSOrGDK = isUe || isUnity;

            // UE引擎,Unity引擎必填这两个版本
            // 选择了PS4/5,必须填 PS SDK版本
            // 选了XSX必须填 GDK版本
            if (
              engineNeedPSOrGDK &&
              hasPSPlatform &&
              hasXSXPlatform &&
              !psSdkContents.length &&
              !gdkContents.length
            ) {
              messageWarning(
                getFormatMessage('ps_sdk_version_and_gdk_version_required')
              );
              return false;
            }

            if (engineNeedPSOrGDK && hasXSXPlatform && !gdkContents.length) {
              messageWarning(getFormatMessage('gdk_version_required'));
              return false;
            }

            if (engineNeedPSOrGDK && hasPSPlatform && !psSdkContents.length) {
              messageWarning(getFormatMessage('ps_sdk_version_required'));
              return false;
            }

            if (!it.ObjectTag) {
              messageWarning('二级下载物名称必填');
              return false;
            }

            console.log('对应的typeValue==', typeValue);
            currentSecondJson.push({
              type: typeValue,
              version: item.version || [],
              platform: item.platform,
              package: item.package,
              gdkVersion: item.openGDKVersion ? item.gdkVersion : [],
              pssdkVersion: item.openPSSDKVersion ? item.pssdkVersion : [],
            });
          }
          newSecondItem.push({
            ObjectTag: it.ObjectTag,
            EngineJson: currentSecondJson,
          });
        }
        newSecondJson[i] = newSecondItem;
      }
    }
    try {
      setLoading(true);
      const updatedValuesWithDecodedServicePath: any = {
        ...omit(values, 'SiteStatus'),
        Description: values.Description || '',
        EngineJson: secondList.length !== 0 ? [] : newEngineJson,
      };

      if (secondList.length !== 0) {
        const newSecond: ISecondEngineItem[] = [];
        Object.keys(newSecondJson).forEach((item) => {
          const jsonItem = newSecondJson[item];
          jsonItem.forEach((it) => {
            newSecond.push(it);
          });
        });
        updatedValuesWithDecodedServicePath.SubVersions = newSecond;
      }

      let res: IMultiSubmitRes = [];

      const hasDuplicateType = newEngineJson.some((engine, index) => {
        return newEngineJson.findIndex((e) => e.type === engine.type) !== index;
      });
      if (
        hasDuplicateType &&
        selectDownloadObjectType === DownloadObjectType.Client
      ) {
        messageError(getFormatMessage('error_same_engine'));
        setLoading(false);
        return false;
      }

      const dataSyncID = await shortHash10(
        updatedValuesWithDecodedServicePath.Version +
          allSiteDownLoadList[getFirstManageSite()]?.find(
            (item) => item.id === values.ObjectID
          )?.Name
      );

      if (props.type === IDownLoadType.Edit && props.row) {
        res = await multiSiteSubmitter(
          (matchedRow: IDownLoadVersionMenu, site) => {
            const body: IDownLoadVersionUpdateConfig = {
              DocLink: form.getFieldValue('DocLink'),
              Status: values.SiteStatus[site],
              EngineJson:
                secondList.length !== 0 && props.row?.EngineJson.length === 0
                  ? []
                  : newEngineJson,
              Description: form.getFieldValue('Description') || '',
            };
            if (secondList.length !== 0 && props.row?.EngineJson.length === 0) {
              const newSecond: ISecondEngineItem[] = [];
              Object.keys(newSecondJson).forEach((item) => {
                const jsonItem = newSecondJson[item];
                jsonItem.forEach((it) => {
                  newSecond.push(it);
                });
              });
              body.SubVersions = newSecond;
            }
            return updateDownLoadVersion(
              matchedRow.id,
              body as IDownLoadVersionUpdateConfig
            );
          },
          getDownloadVersionMatcher(
            values,
            allSiteDownLoadList,
            allSiteDownLoadVersionList
          ),
          (site: string) => {
            const matchedObjectId = getSiteMatchedObjectId(
              values.ObjectID,
              site,
              allSiteDownLoadList
            );
            const params = {
              ...updatedValuesWithDecodedServicePath,
              Status: values.SiteStatus[site],
              ObjectID: matchedObjectId,
            };
            return createDownLoadVersion({
              ...params,
              DataSyncID: dataSyncID,
              DataSource: 'support',
            });
          }
        );
      } else if (props.type === IDownLoadType.Create) {
        res = await multiSiteSubmitter(async (_data: any, site) => {
          const matchedObjectId = getSiteMatchedObjectId(
            values.ObjectID,
            site,
            allSiteDownLoadList
          );
          const params = {
            ...updatedValuesWithDecodedServicePath,
            ObjectID: matchedObjectId,
            Status: values.SiteStatus[site],
          };
          return createDownLoadVersion({
            ...params,
            DataSyncID: dataSyncID,
          });
        });
      }

      setLoading(false);
      return handleMultiSiteSubmitRes(res, {
        onSuccess: () => {
          form.resetFields();
          props.onClose(true);
        },
        successMessage: getSuccessMessage(),
        errorMessage: getFormatMessage('failed_submit'),
      });
    } catch (error: any) {
      messageError(
        error?.apiError?.message || getFormatMessage('failed_submit')
      );
      setLoading(false);
      return false;
    } finally {
    }
  };

  const onDelete = (key: string) => {
    const newEngineJson: IEngineItem[] = [];
    engineJson?.forEach((item: IEngineItem) => {
      if (item.key !== key) {
        newEngineJson.push(item);
      }
    });
    const newSecondJson: Record<string, ISecondEngineItem[]> = {};
    Object.keys(secondJson).forEach((item) => {
      if (item !== key && !newSecondJson[item]) {
        newSecondJson[item] = secondJson[item];
      }
    });
    setSecondJson(newSecondJson);
    setEngineJson(newEngineJson);
  };

  useEffect(() => {
    const { row } = props;
    if (row) {
      // 回显
      form.setFieldsValue({
        ...row,
        SiteStatus:
          row &&
          getNeedManageSites().reduce<Record<string, CommonStatusStep>>(
            (acc, site) => {
              const matchStatus = getSiteMatchedDownloadVersion(
                row,
                site,
                allSiteDownLoadList,
                allSiteDownLoadVersionList
              )?.Status;
              if (matchStatus !== undefined) {
                acc[site] = matchStatus;
              }
              return acc;
            },
            {}
          ),
      });
      handleNameSelectChange(row.ObjectID);
      const matchingItem = downLoadList.find(
        (item) => item.id === props.row?.ObjectID
      );
      if (matchingItem) {
        const correspondingType = matchingItem.Type;
        // console.log('correspondingType222=',correspondingType)
        setSelectDownloadObjectType(correspondingType);
      }
      let updatedEngineJson: any = [];
      if (
        row.SubVersions &&
        row.SubVersions.length !== 0 &&
        row.EngineJson.length === 0
      ) {
        const groupedByVersionType: Record<string, IDownLoadVersionMenu[]> =
          row.SubVersions.reduce<Record<string, IDownLoadVersionMenu[]>>(
            (acc, item) => {
              const key = item.EngineJson[0]?.type;

              if (!key) return acc;

              if (!acc[key]) {
                acc[key] = [];
              }

              acc[key].push(item);
              return acc;
            },
            {}
          );
        Object.keys(groupedByVersionType).forEach((item, index) => {
          const typeList = groupedByVersionType[item];
          updatedEngineJson.push({
            key: `engine-${index}`,
            SubVersions: typeList,
          });
        });
      } else {
        updatedEngineJson = row.EngineJson.map(
          (item: IEngineItem, index: number) => {
            const openPSSDKVersion = item.pssdkVersion.length > 0;
            const openGDKVersion = item.gdkVersion.length > 0;
            return {
              ...item,
              openPSSDKVersion,
              openGDKVersion,
              key: `engine-${index}`,
            };
          }
        );
      }
      setEngineJson(updatedEngineJson || []);
      if (
        row.SubVersions &&
        row.SubVersions.length !== 0 &&
        updatedEngineJson &&
        updatedEngineJson.length !== 0 &&
        row.EngineJson.length === 0
      ) {
        const newSecondJson: any = {};
        updatedEngineJson.forEach((it: any) => {
          const id = (Math.random() * 100).toString(32).slice(3, 7);
          const time = moment().format('YYMMDDHHmmss');
          const newSecondJsonItem = it.SubVersions.map((i: any) => {
            const downloadItem = downLoadList.find(
              (downloadIt) => downloadIt.id === i.ObjectID
            );
            return {
              key: `second-${time}-${id}`,
              ObjectTag: downloadItem?.Tag || '',
              EngineJson: [
                {
                  type: i.EngineJson[0]?.type,
                  version: i.EngineJson[0]?.version,
                  platform: i.EngineJson[0]?.platform,
                  package: i.EngineJson[0]?.package,
                  openGDKVersion: i.EngineJson[0]?.gdkVersion.length > 0,
                  gdkVersion: i.EngineJson[0]?.gdkVersion,
                  openPSSDKVersion: i.EngineJson[0]?.pssdkVersion.length > 0,
                  pssdkVersion: i.EngineJson[0]?.pssdkVersion,
                },
              ],
            };
          });
          newSecondJson[it.key] = newSecondJsonItem;
        });
        setSecondJson(newSecondJson);
      }
    }
    setInit(true);
  }, [props.type, downLoadList]);
  const renderFormItems = () => {
    const { row } = props;
    if (isViewOnly && row) {
      return (
        <>
          <label>基础信息</label>
          <SelectViewField
            label="下载物名称"
            name="ObjectID"
            options={downLoadList.map((item) => {
              return {
                label: item.Name,
                value: item.id,
                type: item.Type,
              };
            })}
          />
          <TextViewField name="Version" label="下载物版本" />
          <TextViewField name="DocLink" label={getFormatMessage('doc')} />
          <TextViewField
            name="Description"
            label={getFormatMessage('description')}
          />

          <Form.Item label={getFormatMessage('启用状态配置')} name="SiteStatus">
            <MultiSiteStatus viewOnly />
          </Form.Item>

          <label style={{ marginBottom: '10px' }}>
            {getFormatMessage('engine')}
          </label>
        </>
      );
    }

    const disabled = props.type === IDownLoadType.Edit;
    const firstList = getFirstDownload();
    return (
      <>
        <label>基础信息</label>

        <Form.Item
          name="ObjectID"
          label="下载物名称"
          rules={[{ required: true }]}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          {firstList ? (
            <CommonSelect
              placeholder="选择下载物名称"
              disabled={disabled}
              onChange={handleNameSelectChange}
              options={firstList}
            ></CommonSelect>
          ) : null}
        </Form.Item>

        <Form.Item
          name="Version"
          label="下载物版本"
          rules={[{ required: true }]}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <CommonInput
            placeholder="输入下载物版本"
            disabled={disabled}
            fullWidth
          ></CommonInput>
        </Form.Item>

        <Form.Item
          name="DocLink"
          label={getFormatMessage('doc')}
          rules={[{ required: true }]}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <CommonInput
            placeholder={getFormatMessage('please_enter_doc')}
            fullWidth
          />
        </Form.Item>

        <Form.Item
          name="Description"
          label={getFormatMessage('description')}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <CommonTextArea
            placeholder={getFormatMessage('please_enter_desc')}
            style={{ height: '80px' }}
          />
        </Form.Item>

        <Form.Item
          label={getFormatMessage('启用状态配置')}
          name="SiteStatus"
          rules={[
            {
              required: true,
              message: getFormatMessage('please_select_status'),
            },
          ]}
        >
          <MultiSiteStatus />
        </Form.Item>

        <label style={{ marginBottom: '10px' }}>
          {getFormatMessage('engine')}
        </label>
      </>
    );
  };

  const handleAddEngine = () => {
    const newEngineJson = Object.assign([], engineJson);
    const id = (Math.random() * 100).toString(32).slice(3, 7);
    const time = moment().format('YYMMDDHHmmss');
    newEngineJson.push({
      key: `engine-${time}-${id}`,
      type: 2,
      version: [],
      platform: [],
      package: [],
      openGDKVersion: false,
      gdkVersion: [],
      openPSSDKVersion: false,
      pssdkVersion: [],
    });
    setEngineJson(newEngineJson);
  };

  const setEngine = (data: IEngineItem) => {
    const newEngineJson: IEngineItem[] = [];
    engineJson.map((item: IEngineItem) => {
      if (item.key === data.key) {
        return newEngineJson.push(data);
      }
      return newEngineJson.push(item);
    });
    setEngineJson(newEngineJson);
  };

  if (!init) return null;
  return (
    <ConsoleDrawer
      // onOk={() => Promise.resolve(true)}
      onClose={handleOpenCancel}
      title={getModalTitle()}
      onOk={handleOpenSubmit}
      okText={getFormatMessage('submit')}
      loading={loading}
      hideFooter={isViewOnly}
    >
      <ConsoleForm form={form}>{renderFormItems()}</ConsoleForm>
      {engineJson.map((item: IEngineItem, index: number) => {
        return (
          <AddEngine
            data={item}
            setEngine={setEngine}
            onDelete={onDelete}
            index={index}
            selectDownloadObjectType={selectDownloadObjectType}
            selectDownloadObjectName={selectDownloadObjectName}
            setLoading={setLoading}
            viewOnly={isViewOnly}
            secondList={secondList}
            secondJson={secondJson}
            setSecondJson={setSecondJson}
            downLoadList={downLoadList}
            row={props.row}
          />
        );
      })}
      {!isViewOnly && (
        <Button className="engine-btn" onClick={handleAddEngine}>
          {getFormatMessage('add_engine')}
        </Button>
      )}
    </ConsoleDrawer>
  );
};
